import { call, fork, select, put, takeLatest, take } from 'redux-saga/effects';

import history from '../history'
import { fetchOrders } from '../api';

import { orderListActions } from './actions';
import { getOrderListById, getCurrentOrderList } from './selectors';

export function* loadOrderList({payload}) {
  const { orderListId } = payload;
  const orderList = yield select(getOrderListById, orderListId);

  if (orderList && orderList.isNew) {
    yield call(fetchOrders, orderListId, orderList.filters);
  }
}

export function* loadOrdersNext() {
  const orderList = yield select(getCurrentOrderList);

  if (orderList.hasNextPageInStore) {
      yield put(orderListActions.updatePagination(orderList.currentPage + 1));
  }
  else if (orderList && orderList.nextUrl) {
      yield call(fetchOrders, orderList.id, { url: orderList.nextUrl, filters: orderList.filters } );
  }
}

export function* loadOrdersPrev() {
  const orderList = yield select(getCurrentOrderList);

  if (orderList.hasPrevPage) {
      yield put(orderListActions.updatePagination(orderList.currentPage - 1));
  }
}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadOrderList() {
  yield takeLatest(orderListActions.LOAD_ORDERS, loadOrderList);
}

export function* watchLoadOrdersNext() {
  yield takeLatest(orderListActions.LOAD_ORDERS_NEXT, loadOrdersNext);
}

export function* watchLoadOrdersPrev() {
  yield takeLatest(orderListActions.LOAD_ORDERS_PREV, loadOrdersPrev);
}


export function* watchNavigateToOrder() {
  while (true) {
    const { payload } = yield take(orderListActions.NAVIGATE_TO_ORDER);
    yield history.push(payload);
  }
}

//=====================================
//  ROOT
//-------------------------------------

export const orderListSagas = [
  fork(watchLoadOrderList),
  fork(watchLoadOrdersNext),
  fork(watchLoadOrdersPrev),
  fork(watchNavigateToOrder),
];
